export default __webpack_public_path__ + "static/media/ImageVideo.17334865.png";